import * as faceapi from '@vladmandic/face-api';

let loadPromise = null;
let isLoaded = false;
let isDetectorLoaded = false;

export const loadFaceApiModels = async () => {
  if (isLoaded) return true;
  if (loadPromise) return loadPromise;

  loadPromise = (async () => {
    try {
      const MODEL_URL = '/models';
      // Load detector first so live bounding works instantaneously
      await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
      isDetectorLoaded = true;

      // Load landmarks and recognition in parallel
      await Promise.all([
        faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
        faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL)
      ]);
      isLoaded = true;
      return true;
    } catch (err) {
      console.error("[FaceAPI] Gagal memuat model:", err);
      loadPromise = null; // Allow retry on failure
      return false;
    }
  })();

  return loadPromise;
};

export const areFaceApiModelsLoaded = () => isLoaded;
export const isFaceDetectorLoaded = () => isDetectorLoaded || isLoaded;
